import React from 'react';
import styled from 'styled-components';
import CheckBtn from '../common/button/CheckBtn';
import CustomNumber from '../common/number/CustomNumber';
import ProdSlider from '../common/slide/ProdSlider';
import TextBox from '../common/box/TextBox';
import { useEffect } from 'react';
import { useState } from 'react';
import { reduce, split, trim, values, findIndex } from 'lodash';
import Modal from 'react-modal';
import EsReqInfoPopup, { EsReqInfoPopupModalStyles } from './EsReqInfoPopup';
import { useSelector, useDispatch } from 'react-redux';
import { addCheckItemAction, delCheckItemAction, resetEsitemInfoAction } from '../../modules/es/esItemModule';
import EsReqDonePopup, { EsReqDonePopupModalStyles } from './EsReqDonePopup';
import EsReqStatusBtn from './EsReqStatusBtn';
import { useHistory, Link } from 'react-router-dom';
import EsOrderDonePopup, { EsOrderDonePopupModalStyles } from './EsOrderDonePopup';
import EsReqStopPopup, { EsReqStopPopupModalStyles } from './EsReqStopPopup';
import {isMobileOnly} from 'react-device-detect';

const EsItemBlock = styled.div`
    ${isMobileOnly?`
    margin-bottom: 10px;
    `:`
    height: 180px;
    margin-bottom: 40px;
    `};
    
    
  .stat, .flex {
    margin:10px 0;
    display: flex;
    align-items: center;
    &.v {flex-direction: column;}
    &.jsb {justify-content: space-between;}
    &.jsa {justify-content: space-around;}
    &.jfn{justify-content: flex-end;}
  }
  
  .ralign {text-align: right;}
  .prod-container {width:92vw; overflow-x: scroll; padding-bottom:15px; border-bottom: 1px solid rgba(121,121,121,0.3)}
  .prod-container-noscroll {width:92vw; overflow-x: hidden; padding-bottom:15px; border-bottom: 1px solid rgba(121,121,121,0.3)}
`;

const EsItemTableBlock = styled.table`
    width: 100%;
    min-height: 187px;
`;

const MobileEsItemBlock = styled.div`
${isMobileOnly?`
        margin: 0 4vw;
        position: relative;
    `:`
        ''
    `};
  .header {
    background-color:#ececec;
    display: flex;
    justify-content: space-between;
    padding:10px 5px;
    align-items: center;
    .brand_name {font-size:1em; font-weight:600;}
  }
`;

const EsItemFtDateTdBlock = styled.td`
    color: #666;
    text-align: center;
    //padding: 30px 10px;
    vertical-align: middle;
`;

const EsItemFtInfoTdBlock = styled.td`
    padding: 10px 10px;
    vertical-align: middle;
    //word-wrap: keep-all;
`;

const EsItemProdsTdBlock = styled.td`
    text-align: center;
    padding: 30px 10px;
    vertical-align: middle;
`;

const EsItemCheckTdBlock = styled.td`
    color: #666;
    text-align: center;
    //padding: 30px 10px;
    vertical-align: middle;
`;

const EsItemInfoBlock = styled.td`
  background-color: #ffffff;
  position: relative;
  //padding: 8px 8px 32px 8px;
  
  &:after {
    //background: linear-gradient(-45deg, #f4f4f4 16px, transparent 0), linear-gradient(45deg, #f4f4f4 16px, transparent 0);
    background: linear-gradient(-135deg, #ffffff 16px , transparent 0), linear-gradient(135deg, #ffffff 16px , transparent 0) ;
    background: #f4f4f4;
   /*  background-image: 
        linear-gradient(45deg, transparent 25%, transparent 25%, 
            transparent 75%, transparent 75%, black),
        linear-gradient(-45deg, transparent 25%, transparent 25%, 
            transparent 75%, transparent 75%, black); */
            background-image: linear-gradient(-135deg, #ffffff 16px , transparent 0), linear-gradient(135deg, #ffffff 16px , transparent 0) ;

    background-position: left-bottom;
    background-repeat: repeat-x;
    background-size: 23px 32px;
    //clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    content: " ";
    display: block;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 32px;
  }
`;

const InfoStatusBlock = styled.div`
    ${isMobileOnly?`
    //width: 180px;
    //float:left;
    padding: 0 0 10px 0;
    `:`
    width: 180px;
    float:left;
    padding: 0 0 0 40px;
    `};
`;

const InfoPackgBlock = styled.div`
    ${isMobileOnly?`
    width: calc(100% - 120px);   
    //height: 180px;
    float:left;
    //padding: 47px 20px;
    `:`
    width: 370px;   
    height: 180px;
    float:left;
    padding: 47px 20px;
    `};
    
    overflow: hidden;
`;

const InfoPackgeBrnadBlock = styled.div`
    ${isMobileOnly?`
    width: 100%;
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    max-height: 48px;
    -webkit-box-orient: vertical;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    word-break: break-all;
    margin-bottom: 4px;
    `:`
    height: 24px;
    margin-bottom: 4px;
    `};
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #333333;
    
    overflow: hidden;
    
`;

const InfoPackageCircleYellowBlock = styled.div`
    width: 4px;
    height: 4px;
    //margin: 4px 154px 4px 0;
    background-color: #ffc742;
    border-radius: 2px;
    margin-bottom: 4px;
`;

const InfoPackageCircleGreenBlock = styled.div`
    width: 4px;
    height: 4px;
    //margin: 4px 154px 4px 0;
    background-color: #79b88a;
    border-radius: 2px;
    margin-bottom: 4px;
`;

const InfoPackgeNameBlock = styled.div`
    ${isMobileOnly?`
    width: 100%;
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    max-height: 48px;
    -webkit-box-orient: vertical;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    word-break: break-all;
    `:`
    height: 22px;
    max-width: 300px;
    word-wrap: break-word;
    //display: -webkit-box;
    //-webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    `}; 

    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    //line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #666666;
    
    margin-bottom: 10px;
    overflow: hidden;

`;

const InfoPackgPdBlock = styled.div`
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    //line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #cccccc;
    height: 18px;
    max-width: 300px;
    overflow: hidden;

    word-wrap: break-word;
    //display: -webkit-box;
    //-webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;

    position: relative;

   /*  &:after{
        content: "${props => props.num}";
        position: absolute;
        left: 100%;
        top: 0;
    }

    span {
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    } */
`;


const InfoPrdctPriceBlock =styled.div`
    ${isMobileOnly?`
    //width: 139px;
    text-align: right;
    float:left;
    padding: 14px 0 5px 0;
    `:`
    width: 139px;
    text-align: right;
    float:left;
    padding: 81px 0 75px 20px;
    `};
`;

const InfoEsPriceBlock = styled.div`
    ${isMobileOnly?`
    text-align: right;
    float:right;
    padding: 10px 0 7px 0;
    `:`
    width: 261px;
    text-align: right;
    float:left;
    padding: 75px 40px 76px 20px;
    `};
`;

const InfoProdImgBlock = styled.div`
    ${isMobileOnly?`
    width: 120px;
    float:right;
    padding: 0 0 0 20px;
    `:`
    width: 180px;
    float:right;
    padding: 40px;
    `};
`;

const InfoProdImg = styled.img`
    border-radius: 4px;
    //min-width: 100%; 
    //min-height: 100%;
    -ms-interpolation-mode: bicubic;
    object-position: center;
    // object-fit: none;
    height: 100px;
    width : 100px;
    vertical-align : middle;
    object-fit: cover;  
`;

const InfoEsPriceTextBlock = styled.div`
    ::before {
        content: "견적";
        color: #79b88a;
        font-size: 14px;
        font-weight: 500;
        margin-right: 10px;
    }
`;

const EsItemInfoMBlock = styled.div`
    width: calc(92vw - 40px);
  //height: 248px;  
  background: #ffffff;
  position: relative;
  padding: 20px;
  float: right;
  
  &:after {
    //background: linear-gradient(-45deg, #f4f4f4 16px, transparent 0), linear-gradient(45deg, #f4f4f4 16px, transparent 0);
    background: linear-gradient(-135deg, #ffffff 16px , transparent 0), linear-gradient(135deg, #ffffff 16px , transparent 0) ;
    background: #f4f4f4;
   /*  background-image: 
        linear-gradient(45deg, transparent 25%, transparent 25%, 
            transparent 75%, transparent 75%, black),
        linear-gradient(-45deg, transparent 25%, transparent 25%, 
            transparent 75%, transparent 75%, black); */
            background-image: linear-gradient(-135deg, #ffffff 16px , transparent 0), linear-gradient(135deg, #ffffff 16px , transparent 0) ;

    background-position: left-bottom;
    background-repeat: repeat-x;
    background-size: 23px 32px;
    //clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    content: " ";
    display: block;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 32px;
  }
`;

const EsItemCheckMBlock = styled.div`
    /* height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left; */
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
`;

const EsItemMLine = styled.div`
    height: 0;
    margin: 12px 0 0;
    border-bottom: solid 1px #cccccc;
`;

const EsItemMPriceBlock = styled.div`
    z-index: 10;
    position: relative;
`;

const EsItem = ({ esItem, handlleIngCheckClick }) => {

    const dispatch = useDispatch();

    const { es_rqst_id, es_id, pckg_nm, code_front, rqst_status,
        expr_date, es_prdct_total_price, es_dscnt_total_price,
        brnd_logo_url, brnd_han, dday, es_pay_price } = esItem[0];

    const [esProdInfo, setEsProdInfo] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const history = useHistory();

    const { esItemCheck } = useSelector(
        ({ userReducer, esItemsReducer }) => ({
            esItemCheck: esItemsReducer.esItemCheck
        })
    );

    useEffect(() => {
        // console.log("esItem : " + JSON.stringify(esItem))
        if (esItem !== null) {
            let info = reduce(esItem, (resobj, curobj, idx) => {
                let catename = split(curobj.cate_name, '>');
                resobj.push([curobj.repr_img, trim(catename[1]), curobj.prdct_id])
                return resobj;
            }, [])

            // console.log("es_rqst_id : " + es_rqst_id);
            setEsProdInfo(info);
        }

    }, [esItem]);

    useEffect(() => {

    }, [esItemCheck])

    const handleCheckClick = (value) => {
        if (value) {
            //dispatch(addCheckItemAction(es_rqst_id));
            handlleIngCheckClick(es_rqst_id);
        } else {
            //dispatch(delCheckItemAction(es_rqst_id))
            handlleIngCheckClick(es_rqst_id);
        }
    }

    const getSlider = () => {
        // console.log(es_rqst_id + "emItem.length : " + esItem.length)
        return <ProdSlider items={esProdInfo} count={esItem.length} />
    }

    if (esProdInfo === null || esProdInfo.length === 0) {
        return <EsItemBlock />
    }

    const handlePckgNmClick = () => {
        dispatch(resetEsitemInfoAction());
        history.push("/esinfo?reqid=" + es_rqst_id);
        //setOpenModal(true);
    }

    const onCloseModal = () => {
        setOpenModal(false);
    }

    // 체크 상태 확인
    const getCheckStatus = () => {
        let idx = findIndex(esItemCheck, (curitem) => {
            return curitem.es_rqst_id === es_rqst_id;
        })
        return (idx >= 0);
    }

    const getProgressInfo = () => {

        if (rqst_status === '050102' || rqst_status === '050103') {
            return ({ width: "30%" });
        } else if (rqst_status === '050104') {
            return ({ width: "50%" });
        } else if (rqst_status === '050105' || rqst_status === '050106') {
            return ({ width: "100%" });
        } else if (rqst_status === '050107') {
            return ({ width: "30%", backgroundColor: '#fc1c67' });
        } else if (rqst_status === '050108') {
            return ({ width: "100%", backgroundColor: '#fc1c67' });
        } else {
            return ({ width: "0%" });
        }
    }

    const getModalComp = () => {
        if (rqst_status === '050105') {
            return (<EsReqDonePopup esItem={esItem}
                onCloseClick={() => { setOpenModal(false) }} />)
        } else if (rqst_status === '050106') {
            return (<EsOrderDonePopup esItem={esItem} od_id={esItem[0].od_id}
                onCloseClick={() => { setOpenModal(false) }} />
            )
        } else if (rqst_status === '050108') { //견적중단
            return (<EsReqStopPopup esItem={esItem}
                onCloseClick={() => { setOpenModal(false) }} />
            )
        } else {
            return (<EsReqInfoPopup esItem={esItem}
                onCloseClick={() => { setOpenModal(false) }} />)
        }
    }

    const getModalStyle = () => {
        if (rqst_status === '050105') {
            return EsReqDonePopupModalStyles;
        } else if (rqst_status === '050106') {
            return EsOrderDonePopupModalStyles;
        } else if (rqst_status === '050108') { //견적중단
            return EsReqStopPopupModalStyles;
        } else {
            return EsReqInfoPopupModalStyles;
        }
    }

    const getStatusBtn = () => {
        const width = isMobileOnly?"fit-content":"fit-content";
        const marginTop = isMobileOnly?"0":"78px";
        const borderRadius=isMobileOnly?"14px":"14px";
        const color = (rqst_status === '050105'&&dday>=0)?"#fff":"#333";
        const bgColor = (rqst_status === '050105'&&dday>=0)?"#111":"#fff";
        const borderColor= (rqst_status === '050105'&&dday>=0)?"#111":"#999999";
        const borderStyle= (rqst_status<="050104"?"dashed":"solid")
        const fontSize=isMobileOnly?"12px":"12px";
        const height=isMobileOnly?"24px":"24px";

        //const onClick= (rqst_status === '050105'&&dday>=0)?(()=>handlePckgNmClick()): (()=>{});
        const onClick= (()=>{});

        let textProps = isMobileOnly?{
            "050108":"견적 중단",
            "050107":"견적 만료",
            "050105":dday>=0?"주문기한 D-"+dday:"주문기한 만료",
            "050104":"진행중",
            "050103":"요청중",
            "050102":"요청중",
        }:{
             "050108":"견적 중단",
             "050107":"견적 만료",
            "050105":dday>=0?"주문기한 D-"+dday:"주문기한 만료",
             "050104":"진행중",
             "050103":"다시 요청중",
             // "050103":"요청중",
             "050102":"요청중",

        };

        // if(!textProps[rqst_status]) textProps[rqst_status] = "진행중";
        if(!textProps[rqst_status]) return null;

        return (<EsReqStatusBtn text={textProps[rqst_status]}
                                width={width}
                                marginTop={marginTop}
                                color={color}
                                bgColor={bgColor}
                                borderColor={borderColor}
                                borderRadius={borderRadius}
                                onClick={onClick}
                                borderStyle={borderStyle}
                                fontSize={fontSize}
                                height={height}
                                padding="0 10px"
        />)

    }

    const getEsPrice = () => {

        let price = 0;
        let fontcolor = "#333333";

        if (rqst_status === '050105') {
            price = es_pay_price;
            fontcolor = "#79b88a"

            return (
                isMobileOnly?
                <InfoEsPriceTextBlock><CustomNumber value={price}
                isPrice={true}
                fontWeight='600' fontSize='20px' color={fontcolor} unitfontSize="18px" unitfontWeight="400"/>
                </InfoEsPriceTextBlock>
                :
            <InfoEsPriceTextBlock><CustomNumber value={price}
                isPrice={true}
                fontWeight='600' fontSize='22px' color={fontcolor} unitfontSize="20px" unitfontWeight="400"/>
                </InfoEsPriceTextBlock>)
        } else {
            price = es_prdct_total_price;
        }

        return (
            isMobileOnly?
            <CustomNumber value={price}
            isPrice={true}
            fontWeight='500' fontSize='20px' color={fontcolor} unitfontSize="18px" unitfontWeight="400"/>
            :
            <CustomNumber value={price}
            isPrice={true}
            fontWeight='500' fontSize='22px' color={fontcolor} unitfontSize="20px" unitfontWeight="400"/>)
    }

    const getProdPrice = () => {

        //디자인 테스트용
        /* if (rqst_status === '050105' ) {
            return (<CustomNumber value={es_prdct_total_price}
                isPrice={true} isCancle={true}
                fontWeight='500' fontSize='16px' color="#cccccc" />)
        } */

        if (rqst_status === '050105' && es_pay_price < es_prdct_total_price) {
            return (
            isMobileOnly?
            <CustomNumber value={es_prdct_total_price}
                isPrice={true} isCancle={true}
                fontWeight='500' fontSize='14px' color="#cccccc" />
            :
            <CustomNumber value={es_prdct_total_price}
                isPrice={true} isCancle={true}
                fontWeight='500' fontSize='16px' color="#cccccc" />)
        } else {
            return "";
        }
    }

    const getNumber = () => {

        if (rqst_status === '050106') {
            return esItem[0].od_id;
        } else {
            return es_rqst_id;
        }
    }

    const getPdNum = () => {
        if(isMobileOnly) {
            if(esItem !== null && esItem[0].prdct_nm !== null && esItem[0].prdct_nm.length > 9 && esItem[0].es_prdct_cnt > 1) {
                return <span>{esItem[0].prdct_nm.substr(0, 9)}...외 {esItem[0].es_prdct_cnt-1}개</span>
            } else if(esItem !== null && esItem[0].prdct_nm !== null && esItem[0].es_prdct_cnt > 1){
                return <span>{esItem[0].prdct_nm} 외 {esItem[0].es_prdct_cnt-1}개</span>;
            } else {
                return <span>{esItem[0].prdct_nm}</span>;
            }
        } else {
            if(esItem !== null && esItem[0].prdct_nm !== null && esItem[0].prdct_nm.length > 20 && esItem[0].es_prdct_cnt > 1) {
                return <span>{esItem[0].prdct_nm.substr(0, 20)}...외 {esItem[0].es_prdct_cnt-1}개</span>
            } else if(esItem !== null && esItem[0].prdct_nm !== null && esItem[0].es_prdct_cnt > 1){
                return <span>{esItem[0].prdct_nm} 외 {esItem[0].es_prdct_cnt-1}개</span>;
            } else {
                return <span>{esItem[0].prdct_nm}</span>;
            }
        }

    }

    return (
        <EsItemBlock>
            {isMobileOnly?
              <MobileEsItemBlock className="clearfix">
                <EsItemCheckMBlock style={{float:'left'}} className="clearfix"><CheckBtn onClick={rqst_status === '050105' ? handleCheckClick:null } defaultValue={getCheckStatus()} disable={rqst_status === '050105' ? false:true}/></EsItemCheckMBlock>
                <EsItemInfoMBlock className="clearfix" onClick={handlePckgNmClick}>
                    <div><InfoStatusBlock>{getStatusBtn()}</InfoStatusBlock></div>
                    <div className="clearfix">
                    <InfoPackgBlock className="clearfix">

                        <InfoPackgeBrnadBlock>{brnd_han}</InfoPackgeBrnadBlock>
                        {
                            rqst_status === '050105' ?
                            <InfoPackageCircleGreenBlock />
                            :
                            <InfoPackageCircleYellowBlock />
                        }
                        <InfoPackgeNameBlock>{pckg_nm}</InfoPackgeNameBlock>
                        <InfoPackgPdBlock>{getPdNum()}</InfoPackgPdBlock>
                    </InfoPackgBlock>
                    <InfoProdImgBlock><InfoProdImg src={esItem[0].repr_img} alt="" /></InfoProdImgBlock>
                    </div>
                    <EsItemMLine />
                    <EsItemMPriceBlock className="clearfix">
                    <InfoPrdctPriceBlock style={rqst_status === '050105'? {float:'left'}:{float:'right'}}>{getProdPrice()}</InfoPrdctPriceBlock>
                    <InfoEsPriceBlock style={{float:'right'}}>{getEsPrice()}</InfoEsPriceBlock>
                    </EsItemMPriceBlock>
                </EsItemInfoMBlock>
            </MobileEsItemBlock>
              :
              <EsItemTableBlock>
                <colgroup>
                    <col width="46px;" />
                    <col width="1130px;" />
                </colgroup>
                <tbody>
                <tr>

                    <EsItemCheckTdBlock>
                        <div style={{float:'left'}}><CheckBtn onClick={rqst_status === '050105' ? handleCheckClick:null } defaultValue={getCheckStatus()} disable={rqst_status === '050105' ? false:true}/></div>
                    </EsItemCheckTdBlock>

                    <EsItemInfoBlock onClick={handlePckgNmClick}>
                        <InfoStatusBlock>{getStatusBtn()}</InfoStatusBlock>
                        <InfoPackgBlock>
                            <InfoPackgeBrnadBlock>{brnd_han}</InfoPackgeBrnadBlock>
                            {
                            rqst_status === '050105' ?
                            <InfoPackageCircleGreenBlock />
                            :
                            <InfoPackageCircleYellowBlock />
                            }
                            <InfoPackgeNameBlock>{pckg_nm}</InfoPackgeNameBlock>
                            <InfoPackgPdBlock>{getPdNum()}</InfoPackgPdBlock>
                        </InfoPackgBlock>
                        <InfoPrdctPriceBlock>{getProdPrice()}</InfoPrdctPriceBlock>
                        <InfoEsPriceBlock>{getEsPrice()}</InfoEsPriceBlock>
                        <InfoProdImgBlock><InfoProdImg src={esItem[0].repr_img} alt="" /></InfoProdImgBlock>
                    </EsItemInfoBlock>

                    {/* <EsItemFtDateTdBlock>
                        <CheckBtn onClick={handleCheckClick} defaultValue={getCheckStatus()} />
                         <CustomNumber
                          value={getNumber()}
                          color="#666" isPrice={false}
                          onClick={handlePckgNmClick}
                          isCancle={false}
                        />
                    </EsItemFtDateTdBlock> */}


                        {/* <EsItemFtDateTdBlock>
                        {getStatusBtn()}
                        </EsItemFtDateTdBlock>
                    <EsItemFtInfoTdBlock onClick={handlePckgNmClick}>
                        <p className="margin_b-10">
                            <Link to={"/brHome/" + esItem[0].brnd_id}>
                                <img src={brnd_logo_url} height="28px" alt="" className="ft_logo" />
                            </Link>
                        </p>
                        <div >
                            <TextBox
                              marginBottom='14px'
                              text={pckg_nm}
                              fontWeight='500'
                              fontSize='16px'
                            />
                        </div>
                        <p className="ft_pay" style={{ cursor: 'pointer' }}>
                            {getEsPrice()} &nbsp;&nbsp;{getProdPrice()}
                        </p>
                    </EsItemFtInfoTdBlock>
                    <EsItemProdsTdBlock>
                        {
                            getSlider()
                        }
                    </EsItemProdsTdBlock> */}
                </tr>
                </tbody>

            </EsItemTableBlock>}
           {/*  {!isMobileOnly&&<div className="es_progess-box">
                <span className="ep-bar" style={getProgressInfo()}>
                    <span className="ep-info">{code_front}</span>
                </span>
            </div>} */}

            <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={getModalStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getModalComp()}
            </Modal>
        </EsItemBlock>
    );
};

export default EsItem;
